import { useSettingsQuery } from 'src/api/queries/userQueries';
import {
  AdminSettingsSection,
  PageBody,
  SaveChangesBar,
  SettingsNavigation,
} from 'src/components';

import styles from './styles.module.scss';
import { Watermark } from './components/Watermark';

export const WatermarkSettings = () => {
  const { isLoading } = useSettingsQuery();

  if (isLoading) {
    return null;
  }

  return (
    <div className={styles.pageWrapper}>
      <SettingsNavigation />
      <SaveChangesBar />

      <PageBody narrow>
        <AdminSettingsSection title="Watermark">
          <Watermark />
        </AdminSettingsSection>
      </PageBody>
    </div>
  );
};
